// Title related endpoints
export const TitleEndpoints = (builder) => ({
  getTitles: builder.query({
    query: (args = {}) => {
      const {
        pageNumber = 1,
        pageSize = 10,
        searchTerm,
        searchValue,
      } = args;

      const params = {
        pageNumber,
        pageSize,
      };

      if (searchTerm) params.searchTerm = searchTerm;
      if (searchValue) params.searchValue = searchValue;

      return {
        url: '/common/title-list',
        method: 'GET',
        params,
      };
    },
    providesTags: ['Title'],
  }),

  getTitleById: builder.query({
    query: (id) => ({
      url: `/common/get-TitleById/${id}`,
      method: 'GET',
    }),
    providesTags: (result, error, id) => [{ type: 'Title', id }],
  }),
});
